export enum FeeItemCategoryIdEnum {
  ValidValue = '7F299C4D-CD95-44BD-9E24-F1013E475F3F',
  Preventative = '00000047-1000-0000-0000-000000000001',
  Basic = '00000047-1000-0000-0000-000000000002',
  Other = '00000047-1000-0000-0000-000000000003'
}
